import React, { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

interface PropTypes extends ComponentProps<"input"> {
  label: string;
  isInvalid?: boolean;
  error?: string;
  containerClassName?: string;
}

const Checkbox = ({
  label,
  isInvalid,
  checked,
  error,
  containerClassName,
  ...rest
}: PropTypes) => {
  return (
    <div className="form-control">
      <label
        className={twMerge(
          "label cursor-pointer flex items-center justify-start space-x-2",
          containerClassName
        )}
      >
        <input
          checked={checked}
          {...rest}
          type="checkbox"
          className="checkbox checkbox-primary text-[1rem] lg:text-xs"
        />
        <span className="label-text-alt text-[1rem] lg:text-xs"> {label}</span>
      </label>
      {isInvalid && error && (
        <div className="label">
          <span className="label-text-alt text-red-600">{error}</span>
        </div>
      )}
    </div>
  );
};

export default Checkbox;
